<!-- Table view for md and up -->
<div class="ion-hide-lg-down">
  <ag-grid-angular
    #agGrid
    [theme]="theme"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [domLayout]="'autoHeight'"
    [defaultColDef]="defaultColDef"
    (rowClicked)="onRowClicked($event)">
  </ag-grid-angular>
</div>

<!-- Card view for sm and down -->
<div class="ion-hide-lg-up">
  <ion-list *ngIf="rowData?.length">
    <ion-card
      *ngFor="let row of rowData"
      [class.hoverable]="hoverable"
      (click)="onRowClicked({ data: row })"
      class="sp-table-card">
      <ion-card-content>
        <div *ngFor="let col of columns">
          <strong>{{ col.name | translate }}: </strong>
          <span>{{ col.propertySelector(row) }}</span>
        </div>
        <div *ngIf="actions?.length" class="sp-table-card-actions">
          <ion-button
            *ngFor="let action of actions"
            size="small"
            fill="clear"
            (click)="$event.stopPropagation(); action.onClick(row)">
            <ion-icon *ngIf="action.icon" [name]="action.icon" slot="start"></ion-icon>
            {{ action.label | translate }}
          </ion-button>
        </div>
      </ion-card-content>
    </ion-card>
  </ion-list>
</div>
